let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8DuKk")).then(() => parcelRequire('7D0E8'));